import React from "react";


import axios from 'axios';
import {Configuration, RncApiApi} from "./generated";
import {serverUrl} from "./Serveur";

const config = new Configuration();
const axiosInstance = axios.create({});

const ctrlApi = new RncApiApi(config, serverUrl, axiosInstance);

export default class RncCtrl extends React.Component {

    static async getRnc(code, callback) {
        ctrlApi.rncGet(code).then((result) => {
            callback(result.data);
        })
    }




}
